import FormCheckbox from "../../shared/FormCheckbox";
import FormSelect from "../../shared/FormSelect";

const step = 7
const StepSeven = ({ activeStep, control, errors, register, getValues, updateAccumulatorFromMapping }) => {
    if (activeStep !== step) return;

    const dedValue = getValues('accumulator.medical.inNetwork.deductible.type')
    const oopValue = getValues('accumulator.medical.inNetwork.outOfPocket.type')

    return (
        <div style={{}}>
            <p style={{ fontWeight: 600, fontSize: '1.2rem', padding: '1rem 0rem' }}>Medical Accumulator In-Network</p>

            <p style={{ fontSize: '1.2rem', fontWeight: '600', padding: '0rem 0rem 1rem 0rem' }}>Deductible</p>
            <FormSelect
                label={'Deductible Type'}
                name={'accumulator.medical.inNetwork.deductible.type'}
                control={control}
                options={[
                    { value: 'Aggregate', label: 'Aggregate' },
                    { value: 'Embedded', label: 'Embedded' },
                    { value: 'None', label: 'None' },
                ]}
                errors={errors}
                placeholder="Select..."
                onSelectedHandler={updateAccumulatorFromMapping}
            />

            <div style={{ padding: '0rem 0rem 2rem 0rem', display: 'flex', gap: '2rem' }}>
                <FormCheckbox
                    label={'Medical INN DED Applies to Medical OON DED?'}
                    name={`accumulator.medical.inNetwork.deductible.tierDeductibleSharing`}
                    register={register}
                    control={control}
                    onSelectedHandler={updateAccumulatorFromMapping}
                    disabled={dedValue?.value == 'None'}
                />
                <FormCheckbox
                    label={'Medical INN DED Applies to Prescription INN DED?'}
                    name={`accumulator.medical.inNetwork.deductible.productTypeDeductibleSharing`}
                    register={register}
                    control={control}
                    onSelectedHandler={updateAccumulatorFromMapping}
                    disabled={dedValue?.value == 'None'}
                />

            </div>

            {/* <div style={{ display: 'flex', gap: '1rem', padding: '' }}> */}
            {/*     <FormInputNumber name={"accumulator.medical.inNetwork.deductible.individualAmt"} label={`Individual Amount`} errors={errors} register={register} /> */}
            {/*     <FormInputNumber name={"accumulator.medical.inNetwork.deductible.empSpouesChild"} label={`Emp+Spouse | Children Amount`} errors={errors} register={register} /> */}
            {/*     <FormInputNumber name={"accumulator.medical.inNetwork.deductible.familyAmt"} label={`Family Amount`} errors={errors} register={register} /> */}
            {/* </div> */}

            <p style={{ fontSize: '1.2rem', fontWeight: '600', padding: '2rem 0rem 1rem 0rem' }}>Out-of-Pocket</p>
            <FormSelect
                label={'Out of pocket Type'}
                name={'accumulator.medical.inNetwork.outOfPocket.type'}
                control={control}
                options={[
                    { value: 'Aggregate', label: 'Aggregate' },
                    { value: 'Embedded', label: 'Embedded' },
                    { value: 'None', label: 'None'},
                ]}
                errors={errors}
                placeholder="Select..."
                onSelectedHandler={updateAccumulatorFromMapping}
            />

            <div style={{ padding: '0rem 0rem 2rem 0rem', display: 'flex', gap: '2rem' }}>
                <FormCheckbox
                    label={'Medical INN OOP Applies to Medical OON OOP?'}
                    name={`accumulator.medical.inNetwork.outOfPocket.tierOutOfPocketSharing`}
                    register={register}
                    control={control}
                    onSelectedHandler={updateAccumulatorFromMapping}
                    disabled={oopValue?.value == "None"}
                />
                <FormCheckbox
                    label={'Medical INN OOP Applies to Prescription INN OOP?'}
                    name={`accumulator.medical.inNetwork.outOfPocket.productTypeOutOfPocketSharing`}
                    register={register}
                    control={control}
                    onSelectedHandler={updateAccumulatorFromMapping}
                    disabled={oopValue?.value == "None"}
                />
            </div>

            {/* <FormInputNumber name={"accumulator.medical.inNetwork.outOfPocket.coinsurance"} label={`Coinsurance`} errors={errors} register={register} style={{ maxWidth: '50%' }} /> */}

            {/* <div style={{ display: 'flex', gap: '1rem', }}> */}
            {/*     <FormInputNumber name={"accumulator.medical.inNetwork.outOfPocket.individualAmt"} label={`Individual Amount`} errors={errors} register={register} /> */}
            {/*     <FormInputNumber name={"accumulator.medical.inNetwork.outOfPocket.empSpouesChild"} label={`Emp+Spouse | Children Amount`} errors={errors} register={register} /> */}
            {/*     <FormInputNumber name={"accumulator.medical.inNetwork.outOfPocket.familyAmt"} label={`Family Amount`} errors={errors} register={register} /> */}
            {/* </div> */}
        </div>
    )
}

export default StepSeven
